const state = {
  cardState: {
    1 : "未激活",
    2 : "正常",
    3 : "停机",
    4 : "销户",
  },
}
const mutations = {

}
const actions = {

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/card.js